import React from 'react';
import { appendClassProps } from '../util';
/**
 - Use text for any text on the screen to conform to typography styles
 */
export const Error = ({ errorMessage, className, showErrorMessage }) => {
    return (React.createElement("div", { className: `text-red-400 text-left pl-2 w-full text-xs h-4${showErrorMessage ? '' : ' text-opacity-0'} ${appendClassProps(className)}`, "data-testid": "error" }, errorMessage ?? ''));
};
//# sourceMappingURL=index.js.map